module.exports = __webpack_public_path__ + "img/160.ef8711fc.jpg";